//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      //   tableLabel:['项目服务','说明'],
      //   tableData:[['出诊检查','检查说明检查说明检查说明'],['复诊检查','检查说明检查说明检查说明']]
    }
  },
  props: {
    tableLabel: {
      type: Array,
      required:true
    },
    tableData:{
      type: Array,
      required:true
    },
    th_style:{ 
        type: Array,
        default() { return []; }
    },
    td_style:{ 
        type: Array,
        default() { return []; }
    },
    left:{
      type: Boolean,
      default:false
    }
  },
  computed:{
    tableValue(){
      const newData= this.tableData.map(item=>{
        return Object.values(item).filter(ele=>ele!==null);
      })
      return newData
    }
  }
}
